import { httpClient } from '@/app/shared/http-service';
import { apiGlobalConstants } from '../config';
import $store from '@/store';

const URL = apiGlobalConstants.tipologia

export const fetchAllTypologies = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : ''

  if (page !== null)
    return httpClient.get(`${URL}/obtener?page=${page}&${filter}`).then(r => r.data)
  else
    return httpClient.get(`${URL}/obtener?${filter}`).then(r => r.data)
}

export const createTypology = (data) => {
  return httpClient.post(`${URL}`, data).then(res => {
    //  TODO: delete store? en la respuesta del api está la clave para indentificar y eliminar
    return res.data
  });
}

export const fetchTypology = (id) => {
  return httpClient.get(`${URL}/${id}`).then(res => res.data);
};

export const putTypology = (id, data) => {
  return httpClient.put(`${URL}/${id}?nombre=${data.nombre}`).then(res => {
    $store.commit('removeStoreTipologia',{ id: id })
    return res.data
  });
}

export const deleteTypology = (id) => {
  return httpClient.delete(`${URL}/${id}`).then(res => {
    $store.commit('removeStoreTipologia',{ id: id })
    return res.data
  });
}

export const orderTypologySon = (id, data) => {
  return httpClient.put(`${URL}/ordenar/${id}`, { hijos: data }).then(r => {
    $store.commit('removeStoreTipologia',{ id: id })
    return res.data
  });
}

export const availableRoutes = () => {
  return httpClient.get(`${URL}/rutas-disponibles`).then(r => r.data)
}

export const fetchTypologyWithSons = (slug) => {
  return httpClient.get(`${URL}/obtener/${slug}`).then(res => {
    // console.warn('Get ' + slug)
    $store.commit('addStore', {
      name: slug,
      tipo: 'tipologia',
      // id: res.data.item.id,
      data: {...res.data, tipo: 'tipologia'}
    });

    return  res.data
  });
}
